"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElementIdServiceImpl = /** @class */ (function () {
    function ElementIdServiceImpl() {
        this.elementIdMap = new Map();
    }
    ElementIdServiceImpl.prototype.generateElementId = function (prefix) {
        if (prefix === void 0) { prefix = 'fkui'; }
        var id = this.nextId(prefix);
        if (document.getElementById(id) === null) {
            return id;
        }
        return this.generateElementId(prefix);
    };
    ElementIdServiceImpl.prototype.nextId = function (prefix) {
        var elementIdWithPadding = String(this.getIdFromMap(prefix));
        while (elementIdWithPadding.length < 4) {
            elementIdWithPadding = '0' + elementIdWithPadding;
        }
        return prefix + "-vue-element-" + elementIdWithPadding;
    };
    ElementIdServiceImpl.prototype.getIdFromMap = function (prefix) {
        var elementId = this.elementIdMap.get(prefix);
        if (!elementId) {
            this.elementIdMap.set(prefix, { count: 1 });
            return 1;
        }
        elementId.count++;
        return elementId.count;
    };
    ElementIdServiceImpl.prototype.reset = function () {
        this.elementIdMap = new Map();
    };
    return ElementIdServiceImpl;
}());
// tslint:disable-next-line:variable-name
exports.ElementIdService = new ElementIdServiceImpl();
//# sourceMappingURL=ElementIdService.js.map